import { render, staticRenderFns } from "./DevolucionesxItem.vue?vue&type=template&id=f0739fbe&scoped=true&"
import script from "./DevolucionesxItem.vue?vue&type=script&lang=js&"
export * from "./DevolucionesxItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0739fbe",
  null
  
)

export default component.exports